export const makeProjectsDashboardViewModel = (
  projectsDashboard: ProjectsDashboardResponse
): ProjectsDashboardViewModel => {
  return { ...projectsDashboard }
}

export type ProjectsDashboardViewModel = ProjectsDashboardResponse & {}

export type ProjectsDashboardResponse = {
  id: string
  totalUpcomingProjects: number
  notCompletedOnTimeProjects: ProjectsStatistics
  notCompletedPastStartProjects: ProjectsStatistics
  notCompletedLateProjects: ProjectsStatistics
  notCompletedOtherProjects: ProjectsStatistics
  groupedNotStartedProjects: GroupedProjects
  groupedInProgressProjects: GroupedProjects
  manualCompletionStatistics: GroupedProjects
  tasksBasedCompletionStatistics: GroupedProjects
  groupedProjectsBasedOnManagers: GroupedProjectsBasedOnResources
  totalNumberOfManagers: number
  totalCompletedProjects: number
  completedOnTimeProjects: string[]
  completedLateProjects: string[]
  completedOtherProjects: string[]
  numberOfCompletedOnTimeProjects: number
  numberOfCompletedLateProjects: number
  numberOfCompletedOtherProjects: number
  percentageOfCompletedOnTimeProjects: number
  percentageOfCompletedLateProjects: number
  percentageOfCompletedOtherProjects: number
  groupedCompletedProjectsBasedOnManagers: GroupedProjectsBasedOnResources
  totalNumberOfManagersInCompletedProjects: number
  completedProjectsBarGraphData: BarGraphData
}

export type GroupedProjects = {
  [key: string]: ProjectsStatistics
}
export type GroupedProjectsBasedOnResources = {
  [key: string]: ProjectsStatistics & {
    name: string
  }
}

export type ProjectsStatistics = {
  projects: string[]
  numberOfProjects: number
  percentageOfProjects: number
}

export type BarGraphData = Array<{
  period: string
  type: string
  projects: string[]
  numberOfProjects: number
  percentageOfProjects: number
}>
